import { ElementType } from 'react';

import { Typography, type TypographyVariant } from '@natu/ui/Typography';

import {
  type SBProps,
  resolveStoryblokStyles,
  sbEditable,
  type FontWeight,
  type TextAlign,
  type FontFamily,
  type Spacing,
  type StoryblokPalette,
} from '../../../../utils';

interface SBTypographyProps {
  content?: string;
  fontSizeMobile?: TypographyVariant;
  fontSizeTablet?: TypographyVariant;
  fontSizeDesktop?: TypographyVariant;
  tag?: ElementType;
  fontWeight?: FontWeight;
  textAlignMobile?: TextAlign;
  textAlignTablet?: TextAlign;
  textAlignDesktop?: TextAlign;
  fontFamily?: FontFamily;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  color?: StoryblokPalette;
}

export const SBTypography = ({ blok }: SBProps<SBTypographyProps>) => {
  const {
    content,
    tag,
    fontSizeMobile,
    fontSizeTablet,
    fontSizeDesktop,
    fontWeight,
    textAlignMobile,
    textAlignTablet,
    textAlignDesktop,
    fontFamily,
    mbMobile,
    mbTablet,
    mbDesktop,
    mtMobile,
    mtTablet,
    mtDesktop,
    color,
  } = blok;

  const fontSizeVariant: [TypographyVariant, TypographyVariant?, TypographyVariant?] = [
    fontSizeMobile!,
    fontSizeTablet || fontSizeMobile,
    fontSizeDesktop || fontSizeTablet || fontSizeMobile,
  ];

  const className = resolveStoryblokStyles({
    fontWeight,
    textAlign: textAlignMobile,
    textAlignTablet,
    textAlignDesktop,
    fontFamily,
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
    className: color?.value ? 'text-[var(--text-sb-color)]' : undefined,
  });

  const style = color?.value
    ? ({ '--text-sb-color': color?.value } as React.CSSProperties)
    : undefined;

  return (
    <Typography
      style={style}
      component={tag || 'p'}
      variant={fontSizeVariant}
      className={className}
      {...sbEditable(blok)}
    >
      {content}
    </Typography>
  );
};
